import routeReplaceSelf from '@/utils/routeReplaceSelf';

const custEmailManagement = {
    path: 'custEmailManagement',
    name: 'custEmailManagement',
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'mailManagementV2',
        icon: 'HSIconfont hs-icon-message',
        showRealm: ['SYSTEM', 'ADMIN']
    },
    children: [
        {
            path: 'custEmailTask',
            name: 'custEmailTask',
            component: routeReplaceSelf(() => import('@/views/custEmailTask/index.vue')),
            meta: { code: 'mailManagementV2:customerTask' },
            children: [
                {
                    path: 'custEmailTaskAdd',
                    name: 'custEmailTaskAdd',
                    hidden: true,
                    component: () => import('@/views/custEmailTask/components/Add'),
                    meta: {
                        code: 'mailManagementV2_customerTask_create',
                        activeMenu: 'custEmailTask',
                    },
                },
                {
                    path: 'custEmailTaskUpdate',
                    name: 'custEmailTaskUpdate',
                    hidden: true,
                    component: () => import('@/views/custEmailTask/components/Edit'),
                    meta: {
                        code: 'mailManagementV2_customerTask_update',
                        activeMenu: 'custEmailTask',
                    },
                },
                {
                    path: 'custEmailSendHistory',
                    name: 'custEmailSendHistory',
                    hidden: true,
                    component: () => import('@/views/custEmailTask/components/SendHistory.vue'),
                    meta: {
                        code: 'mailManagementV2_customerTask_sendHistory',
                        activeMenu: 'custEmailTask',
                    },
                },
            ]
        },
        {
            path: 'custSenderConfig',
            name: 'custSenderConfig',
            component: routeReplaceSelf(() => import('@/views/custSenderConfig/index.vue')),
            meta: { code: 'mailManagementV2:customerSender' },
            children: [
                {
                    path: 'custSenderAdd',
                    name: 'custSenderAdd',
                    hidden: true,
                    component: () => import('@/views/custSenderConfig/components/Add'),
                    meta: {
                        code: 'mailManagementV2_customerSender_create',
                        activeMenu: 'custSenderConfig',
                    },
                },
                {
                    path: 'custSenderUpdate',
                    name: 'custSenderUpdate',
                    hidden: true,
                    component: () => import('@/views/custSenderConfig/components/Edit'),
                    meta: {
                        code: 'mailManagementV2_customerSender_update',
                        activeMenu: 'custSenderConfig',
                    },
                },
            ]
        },
    ]
};

export default custEmailManagement;
